(function() {
    angular.module('emarket.main.profile').factory('Transaction', ['$http', 'PATH', function($http, PATH) {
        return {
            createHash: function(transaction) {
                return $http
                    .post(PATH.api + '/transaction/createHash', transaction)
                    .then(function(response) {
                        return response.data;
                    });
            },
            getByOrderNumber: function(orderNumber) {
                return $http
                    .get(PATH.api + '/transaction?orderNumber=' + orderNumber)
                    .then(function(response) {
                        return response.data;
                    });
            },
            validate: function(response) {
                return $http.post(PATH.api + '/transaction/validate', response).then(function(response) {
                    return response.data;
                });
            },
            getConfig: function() {
                return $http.get(PATH.api + '/transaction/config').then(function(response) {
                    return response.data;
                });
            },
            buyPlan: function(shop) {
                return $http.post(PATH.api + '/transaction/buy', shop).then(function(response) {
                    return response.data;
                });
            }
        };
    }]);
}());
